import * as yup from "yup";

export const companyValidation = (isSuperAdmin) => {
  return yup.object().shape({
    isTidakMelakukanPengelolaanB3: yup.boolean(),

    // Contoh untuk field Penanggung Jawab
    penanggungJawab: yup.string().when("isTidakMelakukanPengelolaanB3", {
      is: (val) => val === true,
      then: (schema) => schema.optional(), // Bebas kosong jika dicentang
      otherwise: (schema) => 
        isSuperAdmin ? schema.optional() : schema.required("Penanggung jawab wajib diisi"),
    }),

    // Contoh untuk field Tipe Perusahaan
    tipePerusahaan: yup.array().when("isTidakMelakukanPengelolaanB3", {
      is: (val) => val === true,
      then: (schema) => schema.optional(), 
      otherwise: (schema) => 
        isSuperAdmin ? schema.optional() : schema.min(1, "Minimal pilih 1 tipe perusahaan"),
    }),

    // Terapkan hal yang sama (.when) untuk field lain seperti alamat, no telp, NPWP, NIB, dll.
  });
};